module.exports = __webpack_public_path__ + "img/109.03613d4d.png";